import React from 'react';
import './Social.css';

const Social = () => {
    return (
        <div>
  <div id="mySidenav" class="sidenav">
  <a href="https://www.linkedin.com/in/hamed-hasan/" target="_blank" id="blog" rel="noreferrer"><i class="ml-14 text-[#0A66C2] fa-brands fa-linkedin"></i></a>
  <a href="https://github.com/Hamed-Hasan" target="_blank" id="contact" rel="noreferrer"><i class="ml-14  fa-brands fa-github"></i></a>
  <a href="whatsapp://send?phone=+966595035008" id="projects"><i class="ml-14 text-[#4DC85B] fa-brands fa-whatsapp"></i></a>
</div>
        </div>
    );
};

export default Social;